<mat-form-field subscriptSizing="dynamic">
    <mat-label *ngIf="label">{{label}}</mat-label>
    <mat-select [required]="required && !value"
                [(value)]="value"
                [panelClass]="isRTLLikeString"
                #control
                [formControl]="internalFormControl"
                (selectionChange)="valueChanged($event)"
                (openedChange)="openedChanged($event)"
                [placeholder]="label || placeholder">
        <mat-form-field *ngIf="shouldHaveFilter"
                        subscriptSizing="dynamic"
                        appearance="fill">
            <input type="text"
                   #searchBox
                   matInput
                   (keydown)="$event.stopPropagation()"
                   [placeholder]="appService.languageSettings.PSTWebSearchLabel"
                   [formControl]="comboBoxFilter"
                   click-stop-propagation>
        </mat-form-field>
        <mat-option *ngIf="addEmptyOption">{{emptyLabel}}</mat-option>
        <ng-template [ngIf]="addSeparatorAfterEmptyOption">
            <mat-divider></mat-divider>
        </ng-template>
        <mat-option *ngFor="let item of filteredOptions | async"
                    [value]="item?.id">
            {{item?.title}}
        </mat-option>
        <ng-template [ngIf]="itemList && additionalItemList.length > 0">
            <mat-divider></mat-divider>
        </ng-template>
        <mat-option *ngFor="let item of filteredTimeZoneOptions | async"
                    [value]="item?.id">
            {{item?.title}}
        </mat-option>
    </mat-select>
    <mat-hint *ngIf="hint">
        {{hint}}
    </mat-hint>
    <ng-container *ngIf="hasSuffix"
                  matSuffix>
        <ng-content select="[suffix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasPrefix"
                  matPrefix>
        <ng-content select="[prefix]"></ng-content>
    </ng-container>
    <ng-container *ngIf="hasError"
                  matError>
        <ng-content select="[error]"></ng-content>
    </ng-container>
</mat-form-field>
